import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  FaPhone,
  FaEnvelope,
  FaBars,
  FaTimes,
  FaChevronDown,
} from "react-icons/fa";
import "./HeaderNew.css";

const HeaderNew = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    { title: "O Nás", link: "/o-nas" },
    { title: "Služby", link: "/sluzby" },
    { title: "Riešenia", link: "/produkty" },
    { title: "Referencie", link: "/referencie" },
    { title: "Bezpečnosť", link: "/bezpecnost" },
    { title: "Webhosting", link: "/webhosting" },
    { title: "Správa PC a sietí", link: "/sprava-pc-sieti" },
    { title: "AI riešenia", link: "/ai-riesenia" },
    { title: "Kontakt", link: "/kontakt" },
    { title: "Podpora", scrollTargetId: "contact-footer" },
  ];

  const isCurrentPage = (item) => {
    if (item.link && location.pathname === item.link) {
      return true;
    }
    if (item.link && item.link !== "/" && location.pathname.startsWith(item.link)) {
      return true;
    }
    if (item.isHome && location.pathname === "/") {
      return true;
    }
    return false;
  };

  return (
    <header className="modern-header">
      <div className="header-container">
        {/* Main header section with logo, navigation and tools */}
        <div className="header-main">
          <div className="logo-section">
            <div className="logo">
              <img
                onClick={() => navigate("/")}
                src="/logo_inv.png"
                alt="INVER s.r.o."
                className="logo-image"
                style={{ cursor: "pointer" }}
              />
            </div>
          </div>

          {/* Navigation menu - desktop */}
          <nav className="nav-menu desktop-nav">
            <ul className="nav-list">
                {menuItems.map((item, index) => (
                  <li
                    key={index}
                    className={`nav-item ${item.isHome ? "nav-home" : ""} ${
                      isCurrentPage(item) ? "nav-active" : ""
                    }`}
                  >
                    {item.scrollTargetId ? (
                      <a
                        href={`#${item.scrollTargetId}`}
                        className="nav-link"
                        onClick={(e) => {
                          e.preventDefault();
                          const el = document.getElementById(item.scrollTargetId);
                          if (el) {
                            const top = el.getBoundingClientRect().top + window.pageYOffset;
                            window.scrollTo({ top, behavior: 'smooth' });
                          }
                        }}
                      >
                        {item.title}
                      </a>
                    ) : (
                      <Link to={item.link} className="nav-link">
                        {item.title}
                      </Link>
                    )}
                  </li>
                ))}
            </ul>
          </nav>

          <button
            className="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        {/* Mobile navigation menu */}
        <div className={`mobile-nav ${isMobileMenuOpen ? "mobile-open" : ""}`}>
          <ul className="mobile-nav-list">
            {menuItems.map((item, index) => (
              <li key={index} className="mobile-nav-item">
                {item.scrollTargetId ? (
                  <a
                    href={`#${item.scrollTargetId}`}
                    className="mobile-nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      const el = document.getElementById(item.scrollTargetId);
                      if (el) {
                        const top = el.getBoundingClientRect().top + window.pageYOffset;
                        window.scrollTo({ top, behavior: 'smooth' });
                      }
                      setIsMobileMenuOpen(false);
                    }}
                  >
                    {item.title}
                  </a>
                ) : (
                  <Link
                    to={item.link}
                    className="mobile-nav-link"
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    {item.title}
                  </Link>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </header>
  );
};

export default HeaderNew;
